import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {CookiePreferencesPage} from "./pages/CookiePreferencesPage.tsx";
import {DeleteAccountPage} from "./pages/DeleteAccountPage.tsx";

export const AccountsLayout = () => {
    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <div>

                        <IndexPage/>
                    </div>
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateAccount') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/accounts'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetAccount') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/accounts'/>
                    )
                }
            />

            <Route
                path="/cookie-preferences"
                element={
                    allowedActions.includes(rbacActions.UpdateUserAccount) ? (
                        <CookiePreferencesPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }/>

            <Route
                path="/delete-account"
                element={
                    allowedActions.includes(rbacActions.DeleteUserAccount) ? (
                        <DeleteAccountPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }/>

            {/* FNP-117: redirect the FNP-122-era route so any existing bookmarks
                still resolve to the real Delete Account page. */}
            <Route
                path="/suspend-account"
                element={<Navigate to='/account/delete-account' replace/>}
            />

        </Routes>
    );
};
